import type { SagGame } from '@ps/web-poker-tile-mappers';

export enum GameType {
  Holdem = 'Holdem',
  HoldemMax = 'HoldemMax',
  HoldemFlash = 'HoldemFlash',
  HoldemSix = 'HoldemSix',
  Omaha = 'Omaha'
}

export type GameTypeName = keyof typeof GameType;

export type Game = SagGame;

export interface GameHoldem extends Game {
  isMax: false;
  isFlash: false;
  game: 'Holdem';
}

export interface GameFlash extends Game {
  isFlash: true;
  game: 'Holdem';
}

export interface GameMax extends Game {
  isMax: true;
  game: 'Holdem';
}

export interface GameHoldemSix extends Game {
  isMax: false;
  isFlash: false;
  isHoldemSix: true;
  game: 'Holdem';
}

export interface GameOmaha extends Game {
  isMax: false;
  isFlash: false;
  game: 'Omaha';
}

export interface GameTypeUrl {
  holdem: string;
  flash: string;
  omaha: string;
  max: string;
  'holdem-six': string;
}

export type GameTypeUrlKey = keyof GameTypeUrl;

export enum GameStake {
  MICRO = 'stake-micro', // 0.25 - 5
  LOW = 'stake-low', // 5.01 - 24.99
  MEDIUM = 'stake-medium', // 25-99.99
  HIGH = 'stake-high', // 100+
  ULTRA = 'stake-ultra' // 1M promo
}

export const GAME_TYPE_URL_MAP: { [key in GameType]: GameTypeUrlKey } = {
  Holdem: 'holdem',
  HoldemMax: 'max',
  HoldemFlash: 'flash',
  HoldemSix: 'holdem-six',
  Omaha: 'omaha'
};

export const GAME_URL_TYPE_MAP: { [key in GameTypeUrlKey]: GameType } = {
  holdem: GameType.Holdem,
  max: GameType.HoldemMax,
  flash: GameType.HoldemFlash,
  'holdem-six': GameType.HoldemSix,
  omaha: GameType.Omaha
};

export const GAME_VARIANT_TYPE_MAP = {
  HOLDEM: GameType.Holdem,
  HOLDEM_MAX: GameType.HoldemMax,
  HOLDEM_FLASH: GameType.HoldemFlash,
  HOLDEM_6: GameType.HoldemSix,
  OMAHA: GameType.Omaha
};

export enum UpdateType {
  Initial = 'Initial',
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete'
}

export interface GamesUpdatePayload {
  games: RawGame[];
  locale: string;
  isPlayMoney: boolean;
  operationType: UpdateType;
}

export interface RawGame {
  information: {
    id?: string | number | null;
    buyin: number | null;
    rake: number | null;
    game: number | null;
    currency: number | null;
    active: boolean | null;
    scriptId: number;
    flags: number | null;
    brandMask: number | null;
    tournSites: number | null;
    scalePM: number | null;
    isHiLo: number | null;
    structure: number | null;
    speed: number | null;
    minPrizePool: number | null;
    maxPrizePool: number | null;
    maxPayout: number | null;
    promoRef: string | null;
    minClientVersion: number | null;
    maxClientVersion: number | null;
    mods: unknown[] | null;
    ticketTypes: unknown[] | null;
    customSpeedDisplayNames: unknown;
    countryRestrictionInverted: boolean;
    countryRestrictions: unknown[] | null;
    visibilityCriteria: string | null;
    mobileNames: unknown;
    tournGroup: number | null;
    admissions: string[] | null;
    tournFlags: number | null;
    pokerNgGroup: string | null;
    tournGroupRef: string | null;
    tournSitesEx: string | null;
    eligibleBrands: unknown[] | null;
    tournFlags2: number | null;
    tournGroupName: string | null;
    sagGroups: unknown[] | null;
    timeBank: number | null;
    modLevels: unknown[] | null;
    additionalVariants: number | null;
    flashModType: number | null;
    flashModTimeBank: number | null;
    vars: unknown[] | null;
    sagPromoTicketShortText: string | null;
    sagPromoTicketLongText: string | null;
  };
  statistics?: Record<string, number | string>;
}
